<template>
    <div :class="{ 'bloco-destaque': classeDestaque }">
        <h4 class="mb-2">Dados gerais da proposta</h4> 

        <p><b>Corretor:</b> {{ (proposta.corretor ? proposta.corretor.label : null) }}</p>
        <p><b>Valor de entrada:</b> {{ formatarDinheiro(proposta.vl_entrada) }}</p>
        <p><b>Data pagamento entrada:</b> {{ converterDataUsParaBr(proposta.dt_pagto_1_parcela) }}</p>
        <p class="mb-3"><b>Data vencimento primeira prestação:</b> {{ converterDataUsParaBr(proposta.dt_pagto_1_parcela) }}</p>

        <h4 class="mb-2">Lote(s)</h4>

        <div class="row">
            <div class="col-12">
                <div v-if="listaLotesAdicionados.length" class="table-responsive">
                    <b-table
                        id="lotes"
                        :fields="colunasLotes"
                        :items="listaLotesAdicionados"
                        sticky-header
                        striped
                        hover
                        style="max-height: 600px">
                    </b-table>
                </div>
                <div v-else class="alert alert-info" role="alert">
                    Nenhum lote adicionado.
                </div>
            </div>
        </div>

        <h4 class="mb-2">Proponente(s)</h4>

        <div class="row">
            <div class="col-12">
                <div v-if="listaProponentesAdicionados.length" class="table-responsive">
                    <b-table
                        id="proponentes"
                        :fields="colunasProponentes"
                        :items="listaProponentesAdicionados"
                        sticky-header
                        striped
                        hover
                        style="max-height: 600px">
                        <template #cell(in_1_proponente)="{ item }">
                            <template v-if="item.in_1_proponente">
                                <b-icon-check-lg variant="success" title="1º Proponente"></b-icon-check-lg>
                            </template>
                        </template>
                    </b-table>
                </div>
                <div v-else class="alert alert-info" role="alert">
                    Nenhum proponente adicionado.
                </div>
            </div>
        </div>

        <h4 class="mb-2">Taxa(s)</h4>

        <div class="row">
            <div class="col-12">
                <div v-if="listaTaxasAdicionadas.length" class="table-responsive">
                    <b-table
                        id="lotes"
                        :fields="colunasTaxas"
                        :items="listaTaxasAdicionadas"
                        sticky-header
                        striped
                        hover
                        style="max-height: 600px">
                    </b-table>
                </div>
                <div v-else class="alert alert-info" role="alert">
                    Nenhuma taxa adicionado.
                </div>
            </div>
        </div>

        <!-- Resumo Financeiro -->
        <div class="card bg-light mt-4 mb-0">
            <div class="card-body">
                <h6 class="font-weight-bold mb-3">Resumo Financeiro</h6>
                <div class="row mb-3">
                    <div class="col-md-3 col-6 mb-2">
                        <small class="text-muted d-block">Entrada</small>
                        <h5 class="mb-0 text-success">{{ formatarDinheiro(valorEntradaNumerico) }}</h5>
                    </div>
                    <div class="col-md-3 col-6 mb-2">
                        <small class="text-muted d-block">Financiamento (prestações)</small>
                        <h5 class="mb-0">{{ formatarDinheiro(vlTotalFinanciamento) }}</h5>
                    </div>
                    <div class="col-md-3 col-6 mb-2">
                        <small class="text-muted d-block">Taxas</small>
                        <h5 class="mb-0">{{ formatarDinheiro(vlTotalTaxaTodasParcelas) }}</h5>
                    </div>
                    <div class="col-md-3 col-6 mb-2">
                        <small class="text-muted d-block">Total geral da venda</small>
                        <h5 class="mb-0 font-weight-bold text-primary">{{ formatarDinheiro(totalGeralVenda) }}</h5>
                    </div>
                </div>
                <div class="border-top pt-2">
                    <small class="text-muted">Resumo: Entrada + Financiamento + Taxas = Total geral</small>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

import api from '@/api/app.api.js';

import Util from '@/util.js';

export default {
    components: {
    },
    props: {
        fichaId: {
            type: Number,
            required: true
        },
        classeDestaque: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    data() {
        return {
            proposta: {
                corretor: null,
                vl_entrada: null,
                dt_pagto_1_parcela: null,
                dt_pagto_1_parcela: null
            },
            listaLotesAdicionados: [],
            listaProponentesAdicionados: [],
            listaTaxasAdicionadas: [],
            fichaCodigo: null,
            fichaStatus: null,
            colunasLotes: [
                { key: 'loteamento', label: 'Loteamento', sortable: true },
                { key: 'lote', label: 'Lote', sortable: true },
                { key: 'qtd_parcelas', label: 'Qtd. Prestações', sortable: true },
                { key: 'vl_total_compra', label: 'Valor. Total', sortable: true, formatter: this.formatarDinheiro},
                { key: 'vl_parcelas', label: 'Valor. Prestações', sortable: true, formatter: this.formatarDinheiro }
            ],
            colunasProponentes: [
                { key: 'in_1_proponente', label: '1º Proponente' },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'nu_cpf', label: 'CPF', sortable: true },
                { key: 'tel_celular', label: 'Telefone', sortable: true },
                { key: 'email', label: 'E-mail', sortable: true },
                { key: 'prof_profissao', label: 'Profissão', sortable: true }
            ],
            colunasTaxas: [
                { key: 'tipo_taxa', label: 'Tipo de Taxa', sortable: true },
                { key: 'descricao', label: 'Descrição', sortable: true },
                { key: 'qtd_parcelas', label: 'Qtd. Parcela', sortable: true },
                { key: 'vl_taxa', label: 'Valor. Total', sortable: true, formatter: this.formatarDinheiro },
                { key: 'vl_parcelas', label: 'Valor. Parcelas', sortable: true, formatter: this.formatarDinheiro },
                { key: 'dt_pagto_1_parcela', label: 'Data Vencimento Primeira Parcela', sortable: true, formatter: this.converterDataUsParaBr }
            ]
        };
    },
    computed: {
        valorEntradaNumerico() {
            return Util.parseValorMonetario(this.proposta && this.proposta.vl_entrada);
        },
        vlTotalFinanciamento() {
            return this.listaLotesAdicionados.reduce((acc, item) => {
                const vl = parseFloat(item.vl_parcelas || 0);
                const qtd = parseFloat(item.qtd_parcelas || 0);
                return acc + vl * qtd;
            }, 0);
        },
        vlTotalTaxaTodasParcelas() {
            return this.listaTaxasAdicionadas.reduce((acc, item) => {
                const vl = parseFloat(item.vl_parcelas || 0);
                const qtd = parseFloat(item.qtd_parcelas || 0);
                return acc + vl * qtd;
            }, 0);
        },
        totalGeralVenda() {
            return this.valorEntradaNumerico + this.vlTotalFinanciamento + this.vlTotalTaxaTodasParcelas;
        }
    },
    async mounted() {
        await this.obterDadosDaProposta();
    },
    methods: {
        ...mapActions('msgErro', { exibirMsgErro: 'exibirMsgErro' }),
        ...mapActions('msgSucesso', { exibirMsgSucesso: 'exibirMsgSucesso' }),
        async obterDadosDaProposta() {
            await api.obterDadosDaProposta(this.fichaId)
                .then(response => {
                    this.prepararDados(response.data);
                })
                .catch((e) => {
                    console.log("e", e);
                    this.exibirMsgErro();
                });
        },
        prepararDados(dados) {
            if (dados === null) {
                return;
            }

            this.proposta = dados.proposta;
            this.listaLotesAdicionados = dados.lotes;
            this.listaProponentesAdicionados = dados.proponentes;
            this.listaTaxasAdicionadas = dados.taxas;
            this.fichaCodigo = dados.codigo;
            this.fichaStatus = dados.status_descricao;
        },
        formatarDinheiro(valor) {
            return Util.formatarDinheiro(valor);
        },
        converterDataUsParaBr(valor) {
            return Util.converterDataUsParaBr(valor);
        }
    }
};
</script>

<style>
    .bloco-destaque {
        padding: 15px; border: 1px solid rgb(197, 197, 197); border-collapse: collapse; background-color: hwb(0 96% 4%);
    }
</style>


// WEBPACK FOOTER //
// src/pages/Contrato/Components/DetalhesProposta.vue